import React, { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { faFileAlt, faInfo, faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"

import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_USERSETING_PARAMS, ENUM_USERSETING_SETVALUE, FixHeight, FixMobileHeight, FixScreenHeight, GetLoginCredentialDb, getModValue, linksUrl } from "../constants/enum.js"
import {
  CompanySelection,
  ErrorCard,
  LoadingCard,
  MainContainer,
  MasterGrid,
  NextUITable,

} from "../components/index.js"
import { useFetchWithBody, usePost, usePostLogin, usePostMutateWithSuccess } from "../api/reactQueryCustomHooks.jsx"
import { resetCompCode, setAppType, setCompCode, setCompInfo, setCurrencyType, setReload, setSalePerson } from "../state/companySlice.jsx"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, TOP_ACTION_BTN_TYPE } from "../components/NextUITable.jsx"
import { addToast, Button, Card, CardBody, Select, SelectItem } from "@heroui/react"
import { setLogout } from "../state/authSlice.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { isMobile } from "react-device-detect"
import { setDetailParams, setNewEntryMode } from "../state/orderSlice.jsx"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { format, toDate } from "date-fns"
import { Box, Typography } from "@mui/material"
import DashBoard from "./DashBoard.jsx"


const Companies = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { yearId, compCode, compName } = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  const queryClient = useQueryClient()
  const [compData, setCompData] = useState([])
  const [selCompany, setSelCompany] = useState("")

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB");
  };

  const { mutate: funGetUserCompMap } = usePostMutateWithSuccess({
    url: apiRoute.userCompMaping.getUserMaping,
    queryKey: "getUsermaping",

  })
  const {
    data: mapCompanyData = [],
    isPending: isPendingComp,
    mutate: getMapComp,
  } = usePost({
    url: apiRoute.userCompMaping.getMappedCompany,
    queryKey: "fungetmasterDatamap",
    onSuccessTasks: (data) => {
      if (data.length > 0) {
        if (selCompany == "" || selCompany == null) {
          const firstCompCode = data[0].CompCode;
          if (compCode && compCode.length > 0) {
            const _CompCode = compCode[0] != firstCompCode ? compCode[0] : firstCompCode
            //  console.log(_CompCode,"sdfdshfj")
            setSelCompany(String(_CompCode));
          }
          else {
            setSelCompany(String(firstCompCode));
          }
        }
      }
    }
  });

  useEffect(() => {
    getMapComp({
      data: { userid: user.username }

    });
  }, []);
  // console.log(ordData)
  //console.log(userCompMapData)
  const {
    isPending,
    isError,
    data = [],
    mutate: funSetYearId
  } = usePost({
    url: apiRoute.setAcYearId,
    queryKey: "Company",
    onSuccessTasks: (data) => {
      const mainCompData = data

      if (mainCompData && mainCompData.length > 0) {
        if (user?.isadmin == 1) {
          
          let selData = mainCompData
          if (selCompany != "" && selCompany != null)
            selData = mainCompData.filter((ele) => ele?.COMPCODE == selCompany)

          setCompData(selData[0])
          setcomInfo([selData[0]])
          dispatch(setSalePerson([]))
        }
        else {
          funGetUserCompMap({
            data: {
              userid: user.username,
            },
            onSuccess: (data) => {
              const userData = data

              if (userData && userData.length > 0) {
                const selComp = userData.map(ele => String(ele.COMPCODE));
                let filterData = mainCompData.filter((ele) => selComp.includes(String(ele.COMPCODE)))
                setCompData(filterData[0])
                setcomInfo([filterData[0]])
                fun_setUseBroMap(filterData[0])
              }
              else {
                setCompData(mainCompData[0])
                setcomInfo([mainCompData[0]])
                fun_setUseBroMap(mainCompData[0])
              }
            }
          })
        }
      }
      else
        setCompCode([])
    }
  })

  // const
  console.log(selCompany)
  const setcomInfo = (selData) => {
    dispatch(setCompCode({ compCode: [selData[0].COMPCODE], compName: [selData[0].COMPNAME], ismulComp: mapCompanyData && mapCompanyData?.length > 1 ? true : false }))
    dispatch(setCompInfo({
      yearId: selData[0]?.YEAR_ID, startDate: selData[0]?.SDATE, endDate: selData[0]?.EDATE,
      state: selData[0]?.STATE, groupCode: selData[0].CGCODE
      , address: selData[0]?.COMP_ADDRESS
      , panNo: selData[0]?.IT_NO
      , objComp: selData
      , gstNo: selData[0]?.Gst_No

    }))

  }


  // const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
  //   url: apiRoute.modSetting.getModSetting,
  //   queryKey: "fetchModSettingCurrency",
  //   inputData: {
  //     mod_name: ENUM_MOD_NAME.GeneralSettings
  //   }
  // })

  const fun_setUseBroMap = (selData) => {

    funGetUserBroMap({
      data: {
        userid: user.username,
        compcode: selData.COMPCODE
      },
      onSuccess: (data) => {

        if (data && data.length > 0)
          dispatch(setSalePerson(data))
        else {
          if (!toast.isActive("toastsmap")) {
            toast.error("Sale Person Maping Not Found  !", {
              "position": "top-center",
              // className: "toast-error"
              toastId: "toastsmap",
              onClose: () => {
                dispatch(setLogout())
                dispatch(resetCompCode())
                navigate(linksUrl.login)
              }
            })

          }
        }
      }
    })
  }


  
  const { data: salePersonData = [], mutate: funGetUserBroMap } = usePostMutateWithSuccess({
    url: apiRoute.userCompMaping.getUserBrokerMaping,
    queryKey: "getUsermaping",

  })

 
  const handleCompChange = (val) => {
    funSetYearId({
      data: {
        ac_year: yearId,
        comp_code: val || ''
      }
    })
  }

  // useEffect(() => {
  //   let CurrencyType = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting)
  //   dispatch(setCurrencyType(CurrencyType ?? ""))
  // }, [modSetting])


  useEffect(() => {
    funSetYearId({
      data: {
        ac_year: yearId,
        comp_code: selCompany || ''
      }
    })
  }, [selCompany])


  const handleNewOrder = () => {
    dispatch(setNewEntryMode(true));
    dispatch(setDetailParams([]));
    navigate(linksUrl.salesOrder.createEntry);
  }

  if (isPending) {
    return <LoadingCard />
  }
  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      {user && user.isadmin == 1 && mapCompanyData && mapCompanyData.length > 1 ?
        <MainContainer pageName={"Company"}
          breadcrumbs={[]}>
          <Card>
            <CardBody className=""
              style={{ height: isMobile ? FixMobileHeight : FixScreenHeight }}
            >
              {/* <CompanySelection
              value={selCompany}
              onChange={(compCode) => {
                setSelCompany(compCode);

              }}
            /> */}
              <div className="p-4 border-1 shadow-md mt-5">
                <h4 className="font-semibold text-pink-600 text-sm uppercase">Current Company</h4>
                <Select
                  className="w-full"
                  isMultiline
                  color="danger"
                  className={"bg-white"}
                  classNames={{
                    label: "font-semibold",
                  }}
                  items={mapCompanyData}
                  label={""}
                  //labelPlacement="outside"
                  //isDisabled={mapCompanyData && mapCompanyData.length==1?true:false}
                  isLoading={isPendingComp}
                  size="md"
                  selectedKeys={selCompany ? [String(selCompany)] : []}
                  selectionMode="single"
                  variant="underlined"
                  onChange={(e) => {
                    const selectedCompCode = e.target.value;
                    selectedCompCode && setSelCompany(selectedCompCode);
                  }}

                >
                  {(item) => (
                    <SelectItem key={item.CompCode}>
                      {item.CompName}
                    </SelectItem>
                  )}
                </Select>
              </div>




            </CardBody>
          </Card>
        </MainContainer>
        : <div>
          <DashBoard />
        </div>
      }

    </div>
  )
}

export default Companies
